import { Pipe, PipeTransform } from '@angular/core';
import { Store } from '@ngxs/store';
import { SamwinSkillsState } from '../../store/samwin/samwin-skills/samwin-skills.state';

@Pipe({
   name: 'isSkillDiversionAllowed',
})
export class IsSkillDiversionAllowedPipe implements PipeTransform {
   constructor(private store: Store) {}

   transform(skillId: number): any {
      return this.store.select(SamwinSkillsState.getIsSkillDiversionAllowedForSkill(skillId));
   }
}
